<footer id="wb-info">
  <carm-main-body-bottom></carm-main-body-bottom>
  <carm-main-footer-main-section></carm-main-footer-main-section>
  <carm-main-footer-bottom-section></carm-main-footer-bottom-section>
</footer>
